import { createSlideIcon, type IconProps } from '../SlideTypeIcon';

const DEFAULT_COLOR = 'var(--palette-purple-500)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M14.1622 15.1339L15.1585 18H18L13.6904 6H10.2927L6 18H8.84117L9.83746 15.1339H14.1622ZM13.2371 12.4778H10.7625L11.9998 8.95543L13.2371 12.4778Z"
    fill={textColor}
  />
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M18.5917 19.7056L19.7956 23.1199H23.2292L18.0217 8.82471H13.9159L8.72876 23.1199H12.1619L13.3658 19.7056H18.5917ZM17.4739 16.5415H14.4836L15.9788 12.3454L17.4739 16.5415Z"
    fill={textColor}
  />
);

export const BigIcon = createSlideIcon(Icon24x24, Icon32x32);
